import {
    Box,
    Button,
    FormControl,
    InputLabel,
    ListSubheader,
    MenuItem,
    Popover,
    Select,
    TextField,
} from "@mui/material";
import * as React from "react";

interface UnitPopupProps {
    unit: WaveUnit;
    units: {
        artillery: any[];
        followers: any[];
        heroes: any[];
    };
    currentUnit: {
        id: number;
        level: number;
        amount: number;
    };
    remove: any;
    save: any;
}

interface UnitPopupState {
    hasChanged: boolean;

    unit: WaveUnit;
    units: {
        artillery: any[];
        followers: any[];
        heroes: any[];
    };

    anchorEl: any;
}

interface WaveUnit {
    id: number;
    position: number;
    level: number;
    amount: number;
}

class UnitPopupWrapped extends React.Component<UnitPopupProps, UnitPopupState> {
    constructor(props) {
        super(props);

        this.state = {
            hasChanged: false,

            unit: props.unit,
            units: props.units,

            anchorEl: null,
        };
    }

    handleOpen = (event: React.MouseEvent<HTMLDivElement>) => {
        if (!this.state.unit.id && this.props.currentUnit.id) {
            this.props.save(this.props.currentUnit);

            this.setState(state => {
                state.unit.id = this.props.currentUnit.id;
                state.unit.level = this.props.currentUnit.level;
                state.unit.amount = this.props.currentUnit.amount;

                return state;
            });

            return;
        }

        this.setState({
            anchorEl: event.currentTarget
        });
    };

    handleClose = () => {
        this.setState({anchorEl: null});

        if (this.state.hasChanged) {
            this.props.save(this.state.unit);
        }
    };

    handleChange = (key: string, value: number | string) => {
        this.setState(state => {
            state.unit[key] = parseInt(value as string, 10);

            state.hasChanged = true;

            return state;
        });
    };

    remove = () => {
        this.setState(state => {
            state.unit.id = null;
            state.anchorEl = null;

            return state;
        });

        this.props.remove();
    };

    render() {
        const {anchorEl} = this.state;
        const waveUnit = this.state.unit;
        const open = Boolean(anchorEl);
        const id = open ? `unit-popover-${waveUnit.id}` : null;

        return <div>
            <div aria-describedby={this.state.unit.position as any} onClick={this.handleOpen}
                 style={{width: "100%", height: "100%"}}>
                &nbsp;
            </div>
            <Popover id={id}
                     open={open}
                     anchorEl={anchorEl}
                     onClose={this.handleClose}
                     anchorOrigin={{
                         vertical: "bottom",
                         horizontal: "center",
                     }}
                     transformOrigin={{
                         vertical: "top",
                         horizontal: "center",
                     }}>
                <Box p={2}>
                    <div style={{width: 200}}>
                        <FormControl style={{width: "100%", marginTop: 5}}>
                            <InputLabel>Unit</InputLabel>
                            <Select value={waveUnit.id || ""}
                                    onChange={(e) => this.handleChange("id", parseInt(e.target.value as string, 10))}
                                    style={{width: "100%"}}>
                                <ListSubheader>Artillery</ListSubheader>
                                {(this.state.units.artillery || []).map(unit => <MenuItem
                                    value={unit.id}>{unit.name}</MenuItem>)}

                                <ListSubheader>Followers</ListSubheader>
                                {(this.state.units.followers || []).map(unit => <MenuItem
                                    value={unit.id}>{unit.name}</MenuItem>)}

                                <ListSubheader>Heroes</ListSubheader>
                                {(this.state.units.heroes || []).map(unit => <MenuItem
                                    value={unit.id}>{unit.name}</MenuItem>)}
                            </Select>
                        </FormControl>

                        <FormControl style={{width: "100%", marginTop: 5}}>
                            <TextField
                                label="Level"
                                type="number"
                                margin="normal"
                                value={waveUnit.level}
                                onChange={(e) => this.handleChange("level", parseInt(e.target.value, 10))}
                                style={{margin: 0, width: "100%"}}
                            />
                        </FormControl>

                        <FormControl style={{width: "100%", marginTop: 5}}>
                            <TextField
                                label="Amount"
                                type="number"
                                margin="normal"
                                value={waveUnit.amount}
                                onChange={(e) => this.handleChange("amount", parseInt(e.target.value, 10))}
                                style={{margin: 0, width: "100%"}}
                            />
                        </FormControl>

                        {waveUnit.id &&
                        <Button disableElevation onClick={this.remove}
                                style={{margin: "5px auto"}}
                                variant="contained" color="primary">
                            Remove this unit
                        </Button>
                        }
                    </div>
                </Box>
            </Popover>
        </div>;
    }
}

export const UnitPopup = UnitPopupWrapped;
